var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinigolfbane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.786,12.629l-1.765-4.35a.832.832,0,0,0-.756-.547H8.3V2.174l0,0,0-.419a.267.267,0,0,0-.367-.24l-2.056.944a.267.267,0,0,0-.023.484l2,.964V7.732H6.441a.853.853,0,0,0-.8.687L4.572,12.768a.921.921,0,0,0,.8,1.188h5.656A.936.936,0,0,0,11.786,12.629Zm-3.825-2.6c-.643,0-1.165-.283-1.165-.63,0-.308.409-.565.947-.619h.111v.448a.224.224,0,0,0,.448,0V8.783h.005c.538.054.818.311.818.619C9.125,9.749,8.6,10.032,7.961,10.032Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinigolfbane);
export default __webpack_public_path__ + "static/media/MINIGOLFBANE.347eac5b8066e0286148aa616fdc66c3.svg";
export { ForwardRef as ReactComponent };